import { render, staticRenderFns } from "./container_detail.vue?vue&type=template&id=8576acde&scoped=true&"
import script from "./container_detail.vue?vue&type=script&lang=js&"
export * from "./container_detail.vue?vue&type=script&lang=js&"
import style0 from "./container_detail.vue?vue&type=style&index=0&id=8576acde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8576acde",
  null
  
)

export default component.exports